import { render, staticRenderFns } from "./RouteRealTime.vue?vue&type=template&id=12cc1a30"
import script from "./RouteRealTime.vue?vue&type=script&lang=js"
export * from "./RouteRealTime.vue?vue&type=script&lang=js"
import style0 from "./RouteRealTime.vue?vue&type=style&index=0&id=12cc1a30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports